import { defineComponent as _defineComponent } from 'vue'
import { translate } from '@/util/commonFun'
import { cloneDeep } from 'lodash'
import { computed, ref } from 'vue'

interface PropsType {
  historyDetail: any
}

interface NestedObject {
  [key: string]: any
}
// 扁平化对象属性(保持了顶层对象的结构，只对第二层及一下的层级进行处理)

export default /*#__PURE__*/_defineComponent({
  __name: 'm-history-form',
  props: {
    historyDetail: null
  },
  setup(__props: any) {

const props = __props as {
  historyDetail: any
}



const titleKeyMap = new Map([
  ['knife', 'preLayoutSetting.knifeDiameter'],
  ['holeFaceSetting', 'cuttingDock.cuttingParams.holeSlotMainSide'],
  ['highgloss_setting', 'cuttingDock.cuttingParams.highGlossSetting'],
  ['cuttingPunchingSetting', 'cuttingDock.cuttingParams.cutHoleWay'],
  ['edgePlankSlotDirection', 'cuttingDock.cuttingParams.sideSlotPut'],
  ['highgloss_setting', 'cuttingDock.cuttingParams.highGlossSetting'],
  ['countertopSetting', 'cuttingDock.labelingSettings.countertopSetting.title'],
  ['trimmingSetting', 'cuttingDock.cuttingParams.edgeSetting'],
  ['surplusSetting', 'cuttingDock.cuttingParams.surplusSetting'],
  ['longPlankCuttingSetting', 'cuttingDock.cuttingParams.longCut'],
  ['decimalSetting', 'cuttingDock.cuttingParams.numberFixed'],
  ['boardGapsSetting', 'cuttingDock.cuttingParams.layoutGap'],
  ['barCodeSetting', 'cuttingDock.NCExportSettings.oneCodeSetting'],
  ['movePlankSetting', 'cuttingDock.cuttingParams.movePlankSetting'],
  ['integrationDeviceSetting', 'common.integration'],
  ['sawSetting', 'cuttingDock.sawEngraving.preLayNav'],
])

const settignKeyMap = new Map([
  ['diameter', 'preLayoutSetting.knifeDiameter'],
  ['holeConcentrated', 'cuttingDock.cuttingParams.holeMainSide'],
  [
    'prorate_holes_slots_of_both_side',
    'cuttingDock.cuttingParams.autoMatchSide',
  ],
  ['apertureSlotConcentrated', 'cuttingDock.cuttingParams.slotMainSide'],
  [
    'processChainAndHoleOnBigPlaneBack',
    'cuttingDock.cuttingParams.hingeRollWork',
  ],
  ['throughHoleSlotSameSide', 'cuttingDock.cuttingParams.followWork'],
  ['percentage_of_back_hole_slot', 'cuttingDock.cuttingParams.backHSRate'],
  [
    'custom_special_hole_slot_side',
    'cuttingDock.cuttingParams.specIalHoleAndSlotSurface',
  ],
  ['highgloss_direction', 'cuttingDock.cuttingParams.heighGlossFront'],
  ['auto_high_gloss_reverse', 'cuttingDock.cuttingParams.highGlossAutoRoll'],
  [
    'high_gloss_plank_no_rotate',
    'cuttingDock.cuttingParams.highGlossPlankNoRotate',
  ],
  ['sideBoardPlacing', 'cuttingDock.cuttingParams.sideSlotPut'],
  [
    'startPosition',
    'cuttingDock.labelingSettings.countertopSetting.startPoint',
  ],
  ['xyReverse', 'common.xyReverse'],
  ['counter_limit_able', '台面宽度限制开关'],
  ['counter_width', '台面宽度'],
  ['longPlankCuttingEnable', 'cuttingDock.cuttingParams.longCut'],
  ['vacuumPumpPauseWay', 'cuttingDock.cuttingParams.pumpOffWay'],
  ['longPlankShortExpandedSize', 'preLayoutSetting.firstShort'],
  ['longPlankExpandedSize', 'preLayoutSetting.firstLong'],
  ['longPlankMinLength', 'preLayoutSetting.cuttingSplitLong'],
  ['longPlankShortMinLength', 'preLayoutSetting.cuttingSplitShort'],
  ['curveSecondCutEnable', 'cuttingDock.cuttingParams.shapeSecondCutenable'],
  ['desMaterialSwitch', 'cuttingDock.cuttingParams.specifyTheMaterial'],
  ['generalPlankThick', 'preLayoutSetting.plankThick'],
  ['single_door_thick', 'preLayoutSetting.singleDoorThick'],
  ['cutSingleDoor', 'common.isDoorPlank'],
  ['cutGeneralPlank', 'common.notDoorPlank'],
  [
    'specified_board_secondary_cutting',
    'cuttingDock.cuttingParams.specifiedBoard',
  ],
  [
    'force_board_name',
    'cuttingDock.cuttingParams.specifiedBoardForceEnable',
  ],
  [
    'secondary_cutting_board_list',
    'preLayoutSetting.secondary_cutting_board_list',
  ],
  ['surplusPosition', 'cuttingDock.cuttingParams.surplusPosition'],
  ['decimal', 'cuttingDock.cuttingParams.numberFixed'],
  ['boardGap', 'cuttingDock.cuttingParams.layoutGap'],
  ['uniqueBarCode', 'cuttingDock.NCExportSettings.uniqueBarCode'],
  ['genSimpleLabelBarcode', 'cuttingDock.NCExportSettings.simplifyOneCode'],
  ['throughTowSideToCut', 'cuttingDock.cuttingParams.cutDeepH'],
  ['through_slot_two_side_cut', 'cuttingDock.cuttingParams.cutDeepS'],
  ['scattered_layout', 'cuttingDock.cuttingParams.scattered_layout'],
  ['safe_length', 'cuttingDock.cuttingParams.minSuctionPlank'],
  ['enable_aio', 'cuttingDock.aioMachineSetting.outputFile'],
  [
    'aio_fixture_setting-aio_avoid_fixture',
    'cuttingDock.aioMachineSetting.duchClampHand',
  ],
  [
    'aio_fixture_setting-aio_first_fixture_height',
    'cuttingDock.aioMachineSetting.clampHandMargin1',
  ],
  [
    'aio_fixture_setting-aio_second_fixture_height',
    'cuttingDock.aioMachineSetting.clampHandMargin2',
  ],
  [
    'aio_fixture_setting-aio_fixture_direction',
    'cuttingDock.aioMachineSetting.clampHandDirection',
  ],
  [
    'aio_fixture_setting-aio_fixture_length',
    'cuttingDock.aioMachineSetting.clampHandLength',
  ],
  [
    'aio_fixture_setting-aio_fixture_width',
    'cuttingDock.aioMachineSetting.clampHandWidth',
  ],
  ['trimSide', 'cuttingDock.cuttingParams.edgeCutDirection'],
  ['mentaoji_enable', 'cuttingDock.sawEngraving.enableSaw'],
  ['processType', 'doorWallCabinet.processingTechnology'],
  ['sawToLayout', 'cuttingDock.sawEngraving.enableSawThick'],
  ['horizontalWidth', 'cuttingDock.sawEngraving.preLayKnifeInput'],
  ['edgeNoSaw', 'cuttingDock.sawEngraving.edgedDir'],
  ['edgeNoSawSide', 'cuttingDock.sawEngraving.edgedDir'],
  ['sameWidthPlank', 'cuttingDock.sawEngraving.sameWidthPart'],
  ['noCutEmptyPath', 'cuttingDock.sawEngraving.emptyPath'],
  ['sawCutOnlyWeld', 'cuttingDock.sawEngraving.sawCutOnlyWeld'],
  ['backCutSurplus', 'cuttingDock.sawEngraving.backCutSurplus'],
])

const valueMap = {
  bottomLeft: 'cuttingDock.cuttingParams.bottomLeftD',
  bottomRight: 'cuttingDock.cuttingParams.bottomRightD',
  topLeft: 'cuttingDock.cuttingParams.topLeftD',
  topRight: 'cuttingDock.cuttingParams.topRightD',
  true: 'preLayoutSetting.on',
  false: 'preLayoutSetting.off',
  default: 'basePlankManager.default',
  inside: 'cuttingDock.cuttingParams.plankInSide',
  outside: 'cuttingDock.cuttingParams.plankOutSide',
  front: 'common.front',
  back: 'common.back',
  after_one_plank: 'cuttingDock.cuttingParams.afterOnePlank',
  after_all_plank: 'cuttingDock.cuttingParams.afterAllPlank',
  L: 'cuttingDock.aioMachineSetting.left',
  R: 'cuttingDock.aioMachineSetting.right',
  T: 'cuttingDock.aioMachineSetting.top',
  B: 'cuttingDock.aioMachineSetting.bottom',
  top: 'cuttingDock.sawEngraving.top',
  bottom: 'cuttingDock.sawEngraving.bottom',
  left: 'cuttingDock.sawEngraving.left',
  right: 'cuttingDock.sawEngraving.right',
  weldingPlank: 'cuttingDock.sawEngraving.weldingPlank',
  doorFrame: 'cuttingDock.sawEngraving.doorFrame',
}

const spcialValueMap = {
  true: 'cuttingDock.cuttingParams.rollThrough',
  false: 'cuttingDock.cuttingParams.onceThrough',
  topLeft: 'cuttingDock.cuttingParams.topLeft',
  bottomLeft: 'cuttingDock.cuttingParams.bottomLeft',
  topRight: 'cuttingDock.cuttingParams.topRight',
  bottomRight: 'cuttingDock.cuttingParams.bottomRight',
}

// 孔槽类型
const typeMap = new Map([
  ['lightSlot', translate('common.lightSlot')],
  ['CCPXHole', translate('common.CCPXHole')],
  ['ALS', translate('common.ALS')],
  ['straightener_slots_and_hinged_cup_holes', translate('common.stretchHinge')],
  ['normalHole', '常规孔'],
  ['normalSlot', '常规槽'],
])
// 孔槽加工面
const surfaceMap: Map<'front' | 'back', string> = new Map([
  ['front', translate('cuttingDock.cuttingParams.blankFront')],
  ['back', translate('cuttingDock.cuttingParams.blankBack')],
])
// 比较值
const compareMap: Map<'gt' | 'lt' | 'eq', string> = new Map([
  ['gt', translate('lineManager.greater')],
  ['lt', translate('lineManager.less')],
  ['eq', translate('lineManager.equal')],
])
// 是否打开特殊孔槽
let isSpecialRule = ref(false)
const titleKeys = computed(() => {
  return historyData.value ? Object.keys(historyData.value) : []
})
const desMaterialList = computed(() => {
  return props.historyDetail.longPlankCuttingSetting.desMaterialList
})
const historyData = computed(() => flatten(props.historyDetail))
const flatten = (obj: NestedObject) => {
  if (!obj || typeof obj !== 'object') {
    return obj
  }
  function flattenNested(nestedObj: NestedObject, prefix = ''): NestedObject {
    const flattened: NestedObject = {}
    for (const key in nestedObj) {
      const newKey = prefix ? `${prefix}-${key}` : key
      const value = nestedObj[key]
      if (typeof value === 'object' && value !== null) {
        Object.assign(flattened, flattenNested(value, newKey))
      } else {
        flattened[newKey] = value
      }
    }
    return flattened
  }
  const result = cloneDeep(obj)
  for (const key in obj) {
    const value = obj[key]
    for (const subKey in value) {
      const subValue = value[subKey]
      // 特殊孔槽规则不做处理
      if (subKey === 'custom_special_hole_slot_side') {
        continue
      }
      // 特殊孔槽自定义需求删除此选项
      if (subKey === 'processChainAndHoleOnBigPlaneBack') {
        delete result[key][subKey]
        continue
      }
      if (
        typeof subValue === 'object' &&
        subValue !== null &&
        !Array.isArray(subValue)
      ) {
        const flattened = flattenNested(subValue, subKey)
        result[key] = { ...result[key], ...flattened }
        delete result[key][subKey]
      }
    }
  }
  return result
}

const dealTitleStr = (key: string) => {
  return translate(titleKeyMap.get(key))
}

const dealSettingStr = (key: string) => {
  return translate(settignKeyMap.get(key))
}

// 需要特殊处理的值
const needSpecialValue = ['cuttingPunchingSetting', 'trimSide']

const dealValueStr = (
  val: keyof typeof valueMap,
  key: string,
  insideKey: string
) => {
  const map: any = needSpecialValue.includes(key) ? spcialValueMap : valueMap
  let result: any = map[val] ? translate(map[val]) : val
  // 特殊孔槽特殊处理
  if (result?.is_open) {
    isSpecialRule.value = result.is_open
    return result.special_hole_slot_side
  }
  if (insideKey === 'desMaterialSwitch' && val) {
    result = desMaterialList.length > 0 ? desMaterialList.join(',') : '开启'
  }

  return result
}

return { __sfc: true,props, titleKeyMap, settignKeyMap, valueMap, spcialValueMap, typeMap, surfaceMap, compareMap, isSpecialRule, titleKeys, desMaterialList, historyData, flatten, dealTitleStr, dealSettingStr, needSpecialValue, dealValueStr, translate }
}

})